import React, {useEffect, useState} from "react";
import axios from "axios";
import {serverLink} from "../../../resources/url";
import Select from "react-select";

function DepartmentSelectOption(props) {
    const [IsLoading, setIsLoading] = useState(true)
    const [itemData, setItemData] = useState([])
    const [formData, setFormData] = useState({
        Item: "",
        ItemObject: "",
    })
    const getData = async () => {
        await axios.get(`${serverLink}staff/academics/department/option/list`)
            .then((result) => {
                let rows = [];
                if (result.data.length > 0) {
                    result.data.map((row) => {
                        rows.push({ value: row.DEPT_ID, label: row.DEPARTMENT })
                    });
                    setItemData(rows);
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }
    useEffect(()=> {
        getData();
    }, [""])

    const onItemChange = (e) => {
        props.setFormData({
            ...props.formData,
            DEPARTMENT_ID:e.value,
            DEPT_ID:e.value
        })
        setFormData({
            ...formData,
            Item: e.value,
            ItemObject: e,
        })
    }

    return (
        <Select
            name="DEPT_ID"
            value={!props.formData.DEPARTMENT_ID || !props.formData.DEPT_ID ? formData.ItemObject : itemData.filter((e,i)=> e.value.toString() === props.formData.DEPARTMENT_ID.toString())[0]}
            onChange={onItemChange}
            options={itemData}
            placeholder="select Department"
        />
    )
}

export default DepartmentSelectOption;